import type { RewriteRequest, RewriteResponse } from '@brandschutz/shared';
import { api } from '@/lib/api';

export async function rewriteText(payload: RewriteRequest): Promise<RewriteResponse> {
  const { data } = await api.post<RewriteResponse>('/ai/rewrite', payload);
  return data;
}
